export const MarketCodes = {
  OPEN_MARKET: 'open-market',
  DIRECT_MAILER: 'direct-mailer',
  BANK_MARKET: 'bank-market',
  LENDING_TREE: 'lending-tree',
  CREDIT_KARMA: 'credit-karma'
};
